"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useLocalizeDate = _interopRequireDefault(require("../hooks/useLocalizeDate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AbsoluteTime = function AbsoluteTime(_ref) {
  var value = _ref.value;
  var absTime = (0, _useLocalizeDate.default)(value);
  var sentAtAbsTime = (0, _useLocalize.default)('SentAt') + absTime;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: sentAtAbsTime
  }), _react.default.createElement("span", {
    "aria-hidden": true
  }, absTime));
};

AbsoluteTime.propTypes = {
  value: _propTypes.default.string.isRequired
};
var _default = AbsoluteTime;
exports.default = _default;